import { UntypedFormGroup } from "@angular/forms";
import { ClaimRequest } from "./claim-request";

export class ClaimFormMapper {

    public static mapClaimRequest(form: UntypedFormGroup): ClaimRequest {
        if (form) {
            let claimForm = form.value;
            let claimRequest: ClaimRequest = new ClaimRequest();

            claimRequest.contractNumber = claimForm.contractNumber;
            claimRequest.customerFirstName = claimForm.customerFirstName;
            claimRequest.customerLastName = claimForm.customerLastName;
            claimRequest.breakdownDate = claimForm.breakdownDate.toLocaleDateString("en-US");
            claimRequest.vin = claimForm.vin;
            claimRequest.customerConcern = claimForm.customerConcern;

            claimRequest.repairFacilityName = claimForm.repairFacilityName ;
            claimRequest.repairFacilityEmail = claimForm.emailAddress;
            claimRequest.repairFacilityPhone = claimForm.phoneNumber;
            claimRequest.repairFacilityPreferredContactMethod = claimForm.repairFacilityPreferredContactMethod;
            claimRequest.repairFacilityContact= claimForm.repairFacilityContactName;

            claimRequest.repairFacilityAddressLine1 = claimForm.streetAddress1;
            claimRequest.repairFacilityAddressLine2 = claimForm.streetAddress2;
            claimRequest.repairFacilityState = claimForm.state;
            claimRequest.repairFacilityCity = claimForm.city;
            claimRequest.repairFacilityZip = claimForm.zip;

            claimRequest.repairFacilityLaborRatePerHour = claimForm.laborRatePerHour;
            claimRequest.repairFacilityLaborManualUsed = claimForm.laborManualUsed;
            claimRequest.repairFacilityPreferredPayment = claimForm.preferredPaymentMethod;            
            
            return claimRequest;
        }
        else {
            return null;
        }
    }
}